import type { ReactElement } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';

export function AppLayout(): ReactElement {
  return (
    <div className="vap-shell">
      <Sidebar />
      <main className="vap-app-main">
        <div className="vap-app-inner">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
